
<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
					"traderName":"",
					"traderType":5,
					"contact":"联系人",
					"phone":"手机号码",
					"parkCode":"",
					"LoginAccount":"",
					"password":"",

				},
				responseCode: {
					"data": {
						"traderCode":"11",
						"traderId":11
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台创建商家",
					t_url: this.commonUrls.test + "createTrader",
					p_url: this.commonUrls.prod + "createTrader",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'traderName',info2: '是',info3: 'String',info4: '商家名称'},
							{info1: 'traderType',info2: '否',info3: 'Integer',info4: '商家类型(0美食/1酒店/2休闲娱乐/3生活服务/4购物/5其他，默认5)'},
							{info1: 'contact',info2: '是',info3: 'String',info4: '联系人'},
							{info1: 'phone',info2: '是',info3: 'String',info4: '手机号码'},
							{info1: 'parkCode',info2: '是',info3: 'String',info4: '所属车场编号'},
							{info1: 'loginAccount',info2: '是',info3: 'String',info4: '账号'},
							{info1: 'password',info2: '是',info3: 'String',info4: '登录密码'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
						{info1: 'traderCode',info2: '是',info3: 'String',info4: '商家编号'},
						{info1: 'traderId',info2: '是',info3: 'Long',info4: '商家id'},

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/createTrader.vue